module.exports = __webpack_public_path__ + "static/media/kathmandu2.651e74dc.ogg";